export const environment = {
  production: true,
  OIDC_API_URL: 'https://authenticate.bnymellon.com/',
  API_BASE_URL: 'https://privacy.bnymellon.com/dsar',
};
